"use client";

import { restDataProvider } from "./rest-data-provider";

export const restDataProviderClient = restDataProvider(process.env.NEXT_PUBLIC_CMS_URL || "http://localhost:8000")
